import { RootState } from 'types'
import { Action } from 'redux/actions'
import { TrackChangesActions } from 'redux/actions/trackChanges'

export default function reduce(
  state: RootState['trackChanges'] = {
    enabled: false,
    showChanges: true,
  },
  action: Action,
): RootState['trackChanges'] {
  switch (action.type) {
    case TrackChangesActions.SET_ENABLED: {
      const { enabled } = action.payload

      return {
        ...state,
        enabled,
        showChanges: enabled,
      }
    }
    case TrackChangesActions.SET_SHOW_CHANGES: {
      const { showChanges } = action.payload
      return {
        ...state,
        showChanges: showChanges,
      }
    }
    default:
      return state
  }
}
